import BacteriasEffect from './BacteriasEffect'

export default BacteriasEffect
